import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import {
  openUser,
  getUserRoles,
  resetUser,
  deleteUser,
  updateUser,
} from '../../../store/actions/users-actions'

import {
  resetUserPassword,
  clearPassword,
} from '../../../store/actions/password-actions'

import {
  getCurrentUserRepresentatives,
  getCurrentUserStores,
  resetSelectedStores,
} from '../../../store/actions/store-info-actions'

import UserDetailsUI from './UI/UserDetailsUI'
import ResetPasswordModal from './ResetPasswordModal'
import DeleteUserModal from './DeleteUserModal'
import { getDefaultForCountry } from '../../../models/languages'
import { useToggle } from '../../../util/utility-hooks'

const UserDetails = props => {
  const [indefiniteDisabled, setIndefiniteDisabled] = useState(false)
  const [showResetPasswordModal, setShowResetPasswordModal] = useToggle(false)
  const [deleteUserModal, toggleDeleteUserModal] = useToggle(false)
  const [passwordResetLoading, setPasswordResetLoading] = useState(false)

  useEffect(() => {
    props.openUser(props.match.params.id)
    props.getUserRoles()
    props.getCurrentUserRepresentatives()
    props.getCurrentUserStores(props.currentRepresentative.id)
  }, [])

  useEffect(() => {
    props.clearPassword()
  }, [showResetPasswordModal])

  useEffect(() => {
    return () => {
      props.resetUser()
      props.resetSelectedStores()
    }
  }, [])

  const handleChangePassword = () => {
    setPasswordResetLoading(false)
    setShowResetPasswordModal(true)
  }

  return (
    props.user &&
    props.validRoles &&
    props.representatives &&
    props.stores &&
    props.selectedStores && (
      <div>
        <UserDetailsUI
          user={props.user}
          loggedInUser={props.loggedInUser}
          validRoles={props.validRoles}
          indefiniteDisabled={indefiniteDisabled}
          stores={props.stores}
          selectedStores={props.selectedStores}
          representatives={props.representatives}
          currentRepresentative={props.currentRepresentative.id}
          onIndefiniteDisable={() => setIndefiniteDisabled(true)}
          onChangeRepresentative={e => props.getCurrentUserStores(e)}
          onChangePassword={handleChangePassword}
          onDelete={toggleDeleteUserModal}
          onSave={user => props.updateUser(user)}
        />

        {showResetPasswordModal && (
          <ResetPasswordModal
            user={props.user}
            loading={passwordResetLoading}
            temporaryPassword={props.temporaryPassword}
            reset={props.reset}
            onReset={() => {
              setPasswordResetLoading(true)
              props.resetUserPassword(
                props.user.id,
                props.user.email,
                props.user.languageCode ||
                  getDefaultForCountry(props.currentRepresentative.country),
              )
            }}
            onClose={setShowResetPasswordModal}
          />
        )}
        {deleteUserModal && (
          <DeleteUserModal
            onDeleteUser={() => {
              props.deleteUser(props.user.id)
              props.history.goBack()
            }}
            onClose={toggleDeleteUserModal}
          />
        )}
      </div>
    )
  )
}

UserDetails.propTypes = {
  match: PropTypes.object.isRequired,
  user: PropTypes.object,
  loggedInUser: PropTypes.object.isRequired,
  validRoles: PropTypes.array,
  temporaryPassword: PropTypes.string,
  reset: PropTypes.bool,
  history: PropTypes.object.isRequired,
  stores: PropTypes.array.isRequired,
  selectedStores: PropTypes.array,
  representatives: PropTypes.array.isRequired,
  currentRepresentative: PropTypes.object.isRequired,
  openUser: PropTypes.func.isRequired,
  getUserRoles: PropTypes.func.isRequired,
  resetUserPassword: PropTypes.func.isRequired,
  clearPassword: PropTypes.func.isRequired,
  resetUser: PropTypes.func.isRequired,
  deleteUser: PropTypes.func.isRequired,
  getCurrentUserRepresentatives: PropTypes.func.isRequired,
  getCurrentUserStores: PropTypes.func.isRequired,
  updateUser: PropTypes.func.isRequired,
  resetSelectedStores: PropTypes.func.isRequired,
}

UserDetails.defaultProps = {
  user: null,
  validRoles: null,
  temporaryPassword: '',
  reset: false,
  selectedStores: null,
}

const mapStateToProps = state => ({
  user: state.users.currentUser,
  loggedInUser: state.auth,
  validRoles: state.users.validRoles,
  temporaryPassword: state.password.temporaryPassword,
  reset: state.password.reset,
  stores: state.storeInfo.stores,
  selectedStores: state.storeInfo.selectedStores,
  representatives: state.storeInfo.representatives,
  currentRepresentative: state.storeInfo.currentRepresentative,
})

const mapDispatchToProps = dispatch => ({
  openUser: userId => {
    dispatch(openUser(userId))
  },
  updateUser: user => {
    dispatch(updateUser(user))
  },
  getUserRoles: () => {
    dispatch(getUserRoles())
  },
  resetUserPassword: (userId, type, language) => {
    dispatch(resetUserPassword(userId, type, language))
  },
  clearPassword: () => {
    dispatch(clearPassword())
  },
  getCurrentUserStores: representativeId => {
    dispatch(getCurrentUserStores(representativeId))
  },
  resetUser: () => {
    dispatch(resetUser())
  },
  resetSelectedStores: () => {
    dispatch(resetSelectedStores())
  },
  deleteUser: userId => {
    dispatch(deleteUser(userId))
  },
  getCurrentUserRepresentatives: () => {
    dispatch(getCurrentUserRepresentatives())
  },
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(UserDetails),
)
